import { Link } from "react-router-dom";
import HeroCountdown from "./HeroCountdown";
import { useTranslation } from "react-i18next";
import { useAdmin } from "../../../contexts/AdminContext";

export default function HeroSection() {
  const { t } = useTranslation();
  const { settings } = useAdmin();

  return (
    <section className="group relative w-full min-h-[52vh] flex flex-col overflow-hidden rounded-[30px] lg:rounded-[50px] bg-slate-900 shadow-2xl cursor-default">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={settings.propertyImages.hero}
          alt={t("home.hero.villa_title")}
          className="w-full h-full object-cover object-center scale-105 animate-slow-zoom transition-transform duration-700 ease-out group-hover:scale-110 group-hover:translate-y-[-8px]"
          onError={(e) => (e.currentTarget.src = "https://images.unsplash.com/photo-1613490493576-7fde63acd811?q=80&w=1600&auto=format&fit=crop")}
        />
        {/* Modern multi-layer overlay */}
        <div className="absolute inset-0 bg-slate-900/40"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/20 to-transparent"></div>
        <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-slate-900/60 to-transparent"></div>
      </div>

      {/* Main Content Container */}
      <div className="relative z-10 flex-1 flex flex-col items-center pt-16 lg:pt-24 pb-10 px-6 max-w-5xl mx-auto w-full">

        {/* Badge Tirage */}
        <div className="mb-5 lg:mb-6 animate-fade-in-down">
          <div className="inline-flex items-center gap-2.5 bg-white/10 backdrop-blur-xl border border-white/20 text-white text-[10px] sm:text-xs font-bold px-4 py-2 rounded-full uppercase tracking-[0.2em] shadow-xl">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-secondary-light opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-secondary"></span>
            </span>
            {t("home.hero.grand_prize")} — <span className="text-primary-light">{settings.nextDrawDate}</span>
          </div>
        </div>

        <h1 className="font-playfair text-3xl sm:text-4xl md:text-[56px] font-black text-white text-center leading-[1.05] mb-4 lg:mb-6 drop-shadow-2xl animate-fade-in">
          {t("home.hero.win_your")}<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-secondary-light via-primary-light to-primary italic font-medium">
            {t("home.hero.dream_house")}
          </span>
        </h1>

        <p className="text-white/80 text-center text-sm sm:text-base md:text-lg max-w-2xl mb-6 lg:mb-8 leading-relaxed font-medium drop-shadow-md">
          {t("home.hero.description", { value: settings.lotteryValue })}
        </p>

        {/* Countdown */}
        <div className="w-full max-w-2xl mx-auto animate-fade-in-up text-center mb-6 lg:mb-8">
          <HeroCountdown />
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 animate-fade-in-up w-full max-w-3xl mx-auto" style={{ animationDelay: "200ms" }}>
          <Link
            to="/forfaits"
            className="group relative bg-primary hover:bg-primary-dark text-white font-black px-8 py-3.5 rounded-full text-base transition-all duration-500 shadow-[0_10px_30px_rgba(247,57,45,0.3)] hover:shadow-[0_15px_40px_rgba(247,57,45,0.5)] hover:-translate-y-1 flex items-center justify-center gap-3 overflow-hidden w-full sm:w-auto"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
            {t("home.hero.buy_tickets")}
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </Link>

          <a
            href="#prizes"
            className="bg-slate-900 border border-slate-700 hover:bg-slate-800 text-white font-bold px-8 py-3.5 rounded-full text-base transition-all duration-300 hover:-translate-y-1 w-full sm:w-auto text-center"
          >
            {t("home.hero.see_prizes")}
          </a>

          <Link
            to="/comment"
            className="text-white/60 hover:text-white font-bold px-6 py-3.5 rounded-full text-base transition-all duration-300 hover:bg-white/5 border border-transparent hover:border-white/10 w-full sm:w-auto text-center flex items-center justify-center gap-2"
          >
            <i className="ri-information-line text-lg"></i>
            Entdecken
          </Link>
        </div>
      </div>
    </section>
  );
}
